import { Ref, ref, reactive, computed } from "vue";
import { DialogService } from "@/service/DialogService";
import { RenrakuService } from "@/service/RenrakuService";
import { RenrakuUser } from "@/types/KaisyaRenraku";

/*
 * 会社連絡宛先ユーザーを検索する処理
 */
export function useSearch() {
  const searchedUserList = ref<RenrakuUser[]>([]);
  const addUserParam = ref<RenrakuUser[]>([]);

  const searchRenrakuUser = (): void => {
    searchedUserList.value = [];
    const srv = new RenrakuService();

    DialogService.nowloading('検索中...');

    srv.searchUsers().then((r: any | null) => {
      if (r !== null) {
        DialogService.info({
          text: r.data.length + `件見つかりました`
        }, true);

        searchedUserList.value = r.data;
      } else {
        DialogService.error({
          text: '予期せぬ事態が発生し検索に失敗しました'
        }, true);
      }
    })
  };

  return {
    addUserParam,
    searchedUserList,
    searchRenrakuUser,
  }
}
